<template>
  <div>
    <!-- 본문 -->
    <v-sheet class="pt-4 mx-auto">
      <!-- 내 사진 내역 없을 시 -->
      <v-sheet v-if="!list.length" class="rounded-10 pt-8 text-center text-subtitle-1 primary--text">
        <v-icon size="40" color="primary" class="mb-2">mdi-cancel</v-icon><br />
        {{ $t("page.mypage.album.empty") }}
      </v-sheet>

      <!-- 내 사진 내역 있을 시 -->
      <v-sheet v-if="list.length" class="py-1">
        <v-row no-gutters>
          <v-col v-for="item in list" :key="`${item.source_type || 'makershot'}-${item.id}`" cols="4" style="border: 1px solid white; cursor: pointer">
            <v-img
              width="100%"
              aspect-ratio="0.8"
              :src="item.thumbnailUrl"
              @click="openDownload(item)"
              :gradient="item.completeStatus == '완료예정' ? 'rgba(92,92,92,.8),rgba(92,92,92,.8)' : ''"
              :style="item.completeStatus === '완료' ? 'cursor: cursor' : 'cursor: default'"
            >
              <div class="sela-bottom-caption d-flex justify-center align-center" :class="item.status != 2 ? 'disabled' : ''">
                <div style="color: white; position: absolute; bottom: 8px; font-size: 0.8rem; text-align: center">
                  {{ getTitle(item.title) }}
                  <br />
                  {{ getDispText(item.completeStatus) }}
                </div>
              </div>
            </v-img>
          </v-col>
        </v-row>
      </v-sheet>
    </v-sheet>
  </div>
</template>
<script>
import { fetchMyPictureItemList } from "@/models/MyPicture"
import { mapState } from "vuex"
import { mayUseEnhancedMyPage } from "@/util/mypageCanary"
import additionalCanaryEmails from "@/config/mypageCanaryAccounts.json"

export default {
  data: () => ({
    list: [],
  }),

  mounted() {
    this.load()
  },

  computed: {
    ...mapState(["lang", "concepts"]),
    isEnhancedMyPage() {
      const canaryEmails = [
        process.env.VUE_APP_MYPAGE_CANARY_EMAILS,
        ...additionalCanaryEmails,
      ]
        .filter(Boolean)
        .join(",")

      return mayUseEnhancedMyPage({
        email: this.$store.state.lafia_user && this.$store.state.lafia_user.email,
        runtimeProfile: process.env.VUE_APP_RUNTIME_PROFILE,
        canaryEmails,
      })
    },
  },

  methods: {
    async load() {
      const legacyRequest = fetchMyPictureItemList(this, this.$store.state.lafia_user.user_id)
      const premiumRequest = this.isEnhancedMyPage
        ? this.$http.get("/api/photo-deliveries/completed").then((response) => response.data).catch(() => [])
        : Promise.resolve([])
      const [{ data: legacyPictures }, premiumPictures] = await Promise.all([legacyRequest, premiumRequest])
      const normalizedPremiumPictures = premiumPictures.map((item) => ({
        ...item,
        thumbnailUrl: item.thumbnail_url,
        imageUrl: item.complete_url,
        processStatus: "complete",
        completeStatus: "완료",
        status: 2,
        source_type: "premium",
      }))

      this.list = [...normalizedPremiumPictures, ...legacyPictures.reverse()]
    },

    openDownload(item) {
      if (item.processStatus == "effect") {
        // TODO: 후보정 안내문구 팝업 필요?
        return
      }
      if (item.completeStatus !== "완료") {
        return
      }

      this.$router.push(`/mypage/picDetail/${item.id}`)
    },

    getDispText(status) {
      if (this.lang === "ko") {
        switch (status) {
          case "완료예정":
            return "작업중"
          default:
            return status
        }
      } else {
        switch (status) {
          case "완료":
            return this.lang === "jp" ? "完了" : "Completed"
          case "완료예정":
            return this.lang === "jp" ? "作業中" : "Progress"
          default:
            return status
        }
      }
    },
    getTitle(conceptTitleKr) {
      const concept = this.concepts.find((c) => c.title === conceptTitleKr)
      switch (this.lang) {
        case "en":
          return (concept && concept.title_en) || conceptTitleKr
          break
        case "jp":
          return (concept && concept.title_jp) || conceptTitleKr

        default:
          return conceptTitleKr
      }
    },
  },
}
</script>
<style scoped></style>
